module.exports = __webpack_public_path__ + "static/media/store_photo_default.8c848eef.jpg";